module.exports = __webpack_public_path__ + "img/4_111.e475b5ae.png";